import { InstagramBrand } from 'blaze-ui/icons/24'
import { WordPressBrand, MailchimpBrand, WixBrand, GoHighLevelBrand } from 'blaze-ui/icons/35'
import { FacebookBrand, LinkedInBrand, TwitterBrand } from 'blaze-ui/icons/35'
import { Shopify, TikTokBrand, YouTubeBrand } from 'blaze-ui/icons'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { BrandPlanTactic } from 'types'

export const organicChannels = [
  {
    title: 'Instagram',
    name: ExternalIntegrationEnum.Instagram,
    icon: InstagramBrand,
  },
  {
    title: 'Facebook',
    name: ExternalIntegrationEnum.Facebook,
    icon: FacebookBrand,
  },
  {
    title: 'LinkedIn',
    name: ExternalIntegrationEnum.LinkedIn,
    icon: LinkedInBrand,
  },
  {
    title: 'Tiktok',
    name: ExternalIntegrationEnum.TikTok,
    icon: TikTokBrand,
  },
  {
    title: 'X/Twitter',
    name: ExternalIntegrationEnum.X,
    icon: TwitterBrand,
  },
  {
    title: 'YouTube',
    name: ExternalIntegrationEnum.YouTube,
    icon: YouTubeBrand,
  },
]

export const blogChannels = [
  {
    title: 'WordPress',
    name: ExternalIntegrationEnum.WordPress,
    icon: WordPressBrand,
  },
  {
    title: 'GoHighLevel',
    name: ExternalIntegrationEnum.GoHighLevel,
    icon: GoHighLevelBrand,
  },
  {
    title: 'Wix',
    name: ExternalIntegrationEnum.Wix,
    icon: WixBrand,
  },
  {
    title: 'Shopify',
    name: ExternalIntegrationEnum.Shopify,
    icon: Shopify,
  },
  {
    title: 'Other Platform',
    name: 'other_blog',
    icon: null,
  },
]

export const emailChannels = [
  {
    title: 'Mailchimp',
    name: ExternalIntegrationEnum.Mailchimp,
    icon: MailchimpBrand,
  },
  {
    title: 'Other Platform',
    name: 'other_email',
    icon: null,
  },
]

export const insightChannelsToTactics = {
  [ExternalIntegrationEnum.Instagram as string]: BrandPlanTactic.Instagram,
  [ExternalIntegrationEnum.Facebook as string]: BrandPlanTactic.Facebook,
  [ExternalIntegrationEnum.LinkedIn as string]: BrandPlanTactic.LinkedIn,
  [ExternalIntegrationEnum.X as string]: BrandPlanTactic.Twitter,
  [ExternalIntegrationEnum.TikTok]: BrandPlanTactic.TikTok,
  [ExternalIntegrationEnum.WordPress as string]: BrandPlanTactic.SEO,
  [ExternalIntegrationEnum.Mailchimp as string]: BrandPlanTactic.Email,
  [ExternalIntegrationEnum.Shopify as string]: BrandPlanTactic.SEO,
}

export const allChannels = [...organicChannels, ...blogChannels, ...emailChannels].filter(
  (channel) => channel.title !== 'Other Platform',
)
